<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 143.309 58.276">
    <g id="SUV" transform="translate(10739.474 690.023)">
      <path id="Path_87070" data-name="Path 87070"
        d="M57.467,106.381a11.68,11.68,0,1,0,3.416,8.26,11.6,11.6,0,0,0-3.416-8.26M56,121.422a9.523,9.523,0,0,1-6.784,2.811H49.2a9.6,9.6,0,0,1-9.594-9.591,9.628,9.628,0,0,1,9.591-9.6h.009A9.6,9.6,0,0,1,56,121.422"
        transform="translate(-10669.852 -758.062)" :fill="themeColor" />
      <path id="Path_87071" data-name="Path 87071"
        d="M18.072,126.314A11.678,11.678,0,1,0,6.395,114.635a11.69,11.69,0,0,0,11.677,11.679m0-21.274a9.6,9.6,0,1,1-9.6,9.6,9.609,9.609,0,0,1,9.6-9.6"
        transform="translate(-10727.647 -758.064)" :fill="themeColor" />
      <path id="Path_87072" data-name="Path 87072"
        d="M143.028,133.885a1.032,1.032,0,0,0,.277-.92c-2.111-11.088-4.607-18.577-6.675-20.031-2.654-1.868-9.317-2.339-18.443-2.8a57.211,57.211,0,0,1-13.142-1.4l-.46-.186a39.159,39.159,0,0,1-7.6-6.264c-4.213-3.976-9.052-8.552-13.516-9.766-11.308-3.053-65.306-1.362-70.37-.837l-.374.034-6.207.551a1.04,1.04,0,0,0-.129,2.045l.326.023,2.631-.234L8.268,96.408c-.08.151-.16.3-.237.457v.328l-.163,0c-2.422,4.907-4.13,11.819-5.15,16.881l-.2.494L.185,118.147a1.034,1.034,0,0,0-.169.568c0,7.481.668,20.031,5.141,20.031h6.05l-.011.006h.234a1.038,1.038,0,0,0,0-2.077H4.857l-.423-.643c-1.32-2-2.282-8.814-2.342-16.578l0-.428,2.419-3.722a1.042,1.042,0,0,0,.149-.368c1.485-7.443,5.036-19.766,8.24-21.085l.831-.149c5.89-.5,58.511-2.074,69.2.811,3.942,1.063,8.58,5.447,12.676,9.317a37.409,37.409,0,0,0,3.725,3.482l3.108,2.536H28.282l-7.129-7.741a1.044,1.044,0,0,0-1.5-.157,1.04,1.04,0,0,0-.114,1.465l7.515,8.175a1.04,1.04,0,0,0,.765.337h84.149a58.6,58.6,0,0,0,6.024.269c8.592.431,15.238.88,17.446,2.434,2.536,2.414,5.55,17.3,5.581,17.452l.149.743L137.078,137a1.04,1.04,0,0,0,1.505,1.434Z"
        transform="translate(-10739.489 -780.757)" :fill="themeColor" />
      <path id="Path_87073" data-name="Path 87073"
        d="M69.2,108.9a1.04,1.04,0,0,0,0-2.079H17.751a1.04,1.04,0,1,0-.006,2.079Z"
        transform="translate(-10708.498 -750.901)" :fill="themeColor" />
    </g>
  </svg>

</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
